import React from "react";

import { Autocomplete, AutocompleteProps, TextField } from "@mui/material";

type Option = { value: number | string; label: string };
type DropdownProps<T> = {
  label: string;
  placeholder: string;
  error?: boolean;
  helperText?: string;
} & Omit<AutocompleteProps<T, false, false, false>, "renderInput">;

export function Dropdown<T extends string | Option>({
  label,
  placeholder,
  error,
  helperText,
  ...autocompleteProps
}: DropdownProps<T>) {
  return (
    <Autocomplete
      size="small"
      multiple={false}
      fullWidth
      // @ts-ignore
      getOptionLabel={(option) => (option.hasOwnProperty("label") ? option.label : option)}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          placeholder={placeholder}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          error={error}
          helperText={helperText}
        />
      )}
      {...autocompleteProps}
    />
  );
}
